
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '国内地区名称',
value: this.$route.params.Item.PLA_Name
}, {
label: '国内地区简称',
value: this.$route.params.Item.PLA_Name_Abbr
}, {
label: '国内地区性质标记',
value: this.$route.params.Item.PLA_AreaNature
}]
}
}



// WEBPACK FOOTER //
// ./src/components/LocationAreaDetail.vue